import React, {Component} from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ReactDataGrid from 'react-data-grid';
import {SkyLightStateless} from 'react-skylight';
import {Toolbar, Data} from 'react-data-grid-addons';
import {UI_HEIGHT} from '../Common/constants';
import {Grid, Row, Col, Panel, Button, ButtonGroup, Table, ButtonToolbar, Breadcrumb } from 'react-bootstrap';
import {Link} from 'react-router';
import {Line, Doughnut} from 'react-chartjs';
import Time from '../Common/time'
import Spinner from '../Widgets/spinner';
import PurchaseQuoteModal from '../../containers/Purchase/purchaseQuoteModal';
import NewFavoriteModal from '../../containers/Favorites/favoriteModal';
import { DatePicker, DisabledDatePicker } from '../Common/datePicker';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import InputField from '../Common/inputField';
import { Field, FieldArray } from 'redux-form';

import { Translate, Localize } from 'react-redux-i18n';

class PurchaseDashboard extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.fourLineButton,

            createReturnOpen: false,
            createQuoteOpen: false,
            createFavoriteOpen: false,

            POs: {
                rows: [],
                allRows: [],
                setDate: null,
                selectedRows: null,
                sortColumn: null,
                sortDirection: null,
            },

            inventories: {
                rows: [],
                selectedRows: null,
                sortColumn: null,
                sortDirection: null,
            },

            favorites: {
                rows: [],
                selectedRows: null,
                sortColumn: null,
                sortDirection: null,
            }
        };

        this.handleResize = this.handleResize.bind(this);

        this.openReturnCreate = this.openReturnCreate.bind(this);
        this.closeReturnCreate = this.closeReturnCreate.bind(this);
        this.openQuoteCreate = this.openQuoteCreate.bind(this);
        this.closeQuoteCreate = this.closeQuoteCreate.bind(this);
        this.openFavoriteCreate = this.openFavoriteCreate.bind(this);
        this.closeFavoriteCreate = this.closeFavoriteCreate.bind(this);
        this.addFavorite = this.addFavorite.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.props.fetchPurchaseOrders();
        this.props.fetchInventories();
        this.props.fetchFavorites();
        this.props.fetchNumPurchaseQuotes();
        this.props.fetchPurchaseOrdersNotReceived();
        this.props.fetchTotalPurchases();
        this.props.fetchPurchasePaymentNotPaid();
        this.props.fetchTodaysIncomingOrders();
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once products are ready, reset state.

    componentWillReceiveProps(nextProps) {
        if (nextProps.todaysIncomingOrders && nextProps.todaysIncomingOrders != this.props.todaysIncomingOrders) {
            let newPurchaseOrders = [...nextProps.todaysIncomingOrders];
            if (newPurchaseOrders.length > 0) {
              newPurchaseOrders.map(index => {
                index.Warehouse = index.Deliver_Warehouse_id.Name;
                index.Vendor = index.Vendor_id.Name;
              });
            }

            let POs = {...this.state.POs, rows: newPurchaseOrders};
            this.setState({POs})
        }

        if (nextProps.inventories && nextProps.inventories != this.props.inventories) {
            var inventories = {...this.state.inventories, rows: nextProps.inventories};
            this.setState({inventories});
        }

        if (nextProps.favorites && nextProps.favorites != this.props.favorites) {
            var favorites = {...this.state.favorites, rows: nextProps.favorites};
            this.setState({favorites});
        }

        if (nextProps.dateChosen && nextProps.dateChosen != this.props.dateChosen) {
            this.props.fetchIncomingOrdersByDate(this.formatDate(nextProps.dateChosen));
        }
    }

    formatDate(date) {
      var monthShortNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      if (date) {
        var month = String(date).slice(4,7);
        var day = String(date).slice(8,10);
        var year = String(date).slice(11, 15);

        let chosenDateFormatted = '';
        if ( parseInt(monthShortNames.indexOf(month) + 1) < 10) {
          chosenDateFormatted = chosenDateFormatted + '0' + (monthShortNames.indexOf(month)+1) + day;
        } else {
          chosenDateFormatted = chosenDateFormatted + (monthShortNames.indexOf(month)+1) + day;
        }
        chosenDateFormatted = chosenDateFormatted + year;
        console.log(chosenDateFormatted);
        return chosenDateFormatted;
      }
      return null;
    }

    openQuoteCreate() {
        this.setState({createQuoteOpen: true});
    }

    openFavoriteCreate() {
        this.setState({createFavoriteOpen: true});
    }

    closeQuoteCreate() {
        this.setState({createQuoteOpen: false});
    }

    closeFavoriteCreate() {
        this.setState({createFavoriteOpen: false});
    }

    openReturnCreate() {
        this.setState({createReturnOpen: true});
    }

    closeReturnCreate() {
        this.setState({createReturnOpen: false});
    }

    addFavorite(newFavorite) {
        console.log("newFavorite", newFavorite)
        let newRow = {
          Product_id: newFavorite.Product_id,
          ProductNum: newFavorite.ProductNum,
          RefNum: newFavorite.ProductNum,
          PreSale: newFavorite.PreSale,
          InStock: newFavorite.InStock,
          Ordered: newFavorite.Purchased,
          Price: newFavorite.RefPurchasingPrice,
          ProductName: newFavorite.Name
        }
        if (newFavorite.Product) {
          newRow.ProductName = newFavorite.Product["Name"];
        }

        let preRows = this.state.favorites.rows;
        preRows.push(newRow);
        var favorites = {...this.state.favorites, rows: preRows}
        this.setState({favorites});
    }

    handleResize(e) {
        this.setState({tableHeight: window.innerHeight - UI_HEIGHT.fourLineButton});
    }

    // Set product being selected to be currentProduct and navigate user to the edit page

    setCurrentPurchaseOrder(e) {
        e.preventDefault();
        const currentPurchaseOrder = this.state.selectedRows[0];
        this.props.resetCurrentPurchaseOrder();
        this.props.selectPurchaseOrder(currentPurchaseOrder);
        this.context.router.push('/purchaseOrder/' + currentPurchaseOrder.PurchaseOrder_id);
    }

    clickNew(e) {
        e.preventDefault();
        this.props.resetCurrentPurchaseOrder();
        this.context.router.push('/purchaseOrder/new')
    }

    createPurchaseReturn(e) {
        e.preventDefault();
        this.props.resetCurrentPurchaseReturn();
        this.context.router.push('/purchaseReturn/new');
    }

    // Render the table head and bind it to the datatable plugin to show a sortable table.

    renderPurchaseOrderTable() {
        if (this.props.todaysIncomingOrdersIsLoading && !this.props.todaysIncomingOrdersError) return <Spinner/>
        else if (this.props.todaysIncomingOrdersError) return <ContentWrapper>
            <div className="alert alert-danger">{JSON.stringify(this.props.todaysIncomingOrdersError)}</div>
        </ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state.POs);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var POs = {...this.state.POs, sortColumn, sortDirection};
                this.setState({POs});
            }

            // Handle the row select function

            const onRowSelect = rows => {
                var POs = {...this.state.POs, selectedRows: rows};
                this.setState({POs});
            }

            //Custom Formatter component

            const DateFormatter = React.createClass({
                render() {
                    if (this.props.value) {
                      let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                      let date = new Date(this.props.value)
                      let index = dateMap.indexOf(date.toString().slice(4,3));
                      let localDate = index + date.toString().slice(8, 6);
                      return <span>{date.toString().slice(4, 15)}</span>;;
                    }
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNumFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            // Column difinition

            const columns = [
                {
                    key: 'PONum',
                    name: <Translate value="po_num" />,
                    resizable: true,
                    sortable: true,
                    width: 90
                },
                {
                    key: 'Vendor',
                    name: <Translate value="vendor" />,
                    resizable: true,
                    sortable: true,
                },
                {
                    key: 'TotalPrice',
                    name: <Translate value="total_dollarsign" />,
                    resizable: true,
                    sortable: true,
                    width: 75,
                },
                {
                    key: 'Warehouse',
                    name: <Translate value="shipto" />,
                    resizable: true,
                    sortable: true,
                    width: 70
                },
                {
                    key: 'CreateTime',
                    name: <Translate value="ordered" />,
                    resizable: true,
                    sortable: true,
                    width: 90,
                    formatter: DateFormatter
                },
                {
                    key: 'PurchaseStatus',
                    name: <Translate value="status" />,
                    resizable: true,
                    sortable: true,
                    width: 80
                },
            ]

            return (
              //React Table Purchase Order Table
                <Row>
                  <Col sm={ 12 }>
                    <div id="PurchaseDashboard-dataGrid1">
                        <ReactDataGrid
                            rowKey='PurchaseOrder_id'
                            onGridSort={handleGridSort}
                            columns={columns}
                            rowGetter={rowGetter}
                            rowsCount={getSize() }
                            minHeight={this.state.tableHeight}
                            rowHeight={25}
                            onRowSelect={onRowSelect}/>
                    </div>
                </Col>
              </Row>
            )
        }
    }

    renderInventoryTable() {
        if (this.props.favoritesAreLoading && !this.props.favoritesError) return <Spinner/>
        else if (this.props.favoritesError) return <ContentWrapper>
            <div className="alert alert-danger">{JSON.stringify(this.props.favoritesError)}</div>
        </ContentWrapper>
        else {
            // Parameters of the react-data-grid

            // const getRows = () => {
            //     return Data.Selectors.getRows(this.state.inventories);
            // }

            const getRows = () => {
                return Data.Selectors.getRows(this.state.favorites);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            // const handleGridSort = (sortColumn, sortDirection) => {
            //     var inventories = {...this.state.inventories, sortColumn, sortDirection};
            //     this.setState({inventories});
            // }

            const handleGridSort = (sortColumn, sortDirection) => {
                var favorites = {...this.state.favorites, sortColumn, sortDirection};
                this.setState({favorites});
            }

            // Handle the row select function

            // const onRowSelect = rows => {
            //     var inventories = {...this.state.inventories, selectedRows: rows};
            //     this.setState({inventories});
            // }

            const onRowSelect = rows => {
                var favorites = {...this.state.favorites, selectedRows: rows};
                this.setState({favorites});
            }

            //Custom Formatter component

            const DateFormatter = React.createClass({
                render() {
                    if (this.props.value) {
                      let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                      let date = new Date(this.props.value)
                      let index = dateMap.indexOf(date.toString().slice(4,3));
                      let localDate = index + date.toString().slice(8, 6);
                      return <span>{date.toString().slice(4, 15)}</span>;;
                    }
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNameFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.Name}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            const VendorNumFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span>{this.props.value.VendorNum}</span>;
                    else return <span className="label label-danger">-</span>;
                }
            });

            // Column difinition

            const columns = [
                {
                    key: 'ProductName',
                    name: <Translate value="product" />,
                    resizable: true,
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'PreSale',
                    name: <Translate value="presale" />,
                    resizable: true,
                    sortable: true,
                    width: 80,
                    filterable: true
                },
                {
                    key: 'InStock',
                    name: <Translate value="stock" />,
                    resizable: true,
                    sortable: true,
                    width: 80
                },
                {
                    key: 'Ordered',
                    name: <Translate value="ordered" />,
                    resizable: true,
                    sortable: true,
                    width: 90
                },
                {
                    key: 'Price',
                    name: <Translate value="cost" />,
                    resizable: true,
                    sortable: true,
                    width: 80
                }
            ]

            return (
              //React Table Inventory Table
                <Row>
                  <Col sm={ 12 }>
                    <div id="PurchaseDashboard-dataGrid2">
                        <ReactDataGrid
                            rowKey='Product_id'
                            onGridSort={handleGridSort}
                            columns={columns}
                            rowGetter={rowGetter}
                            rowsCount={getSize() }
                            minHeight={this.state.tableHeight}
                            rowHeight={25}
                            enableRowSelect='multi'
                            onRowSelect={onRowSelect}/>
                    </div>
                </Col>
              </Row>
            )
        }
    }

    renderDatePicker(handleSubmit) {
      return (
        <form onSubmit={handleSubmit}>
          <Field name="SelectedDate" component={ DatePicker } />
        </form>
      )
    }

    renderNumPurchaseQuotes() {
      if (this.props.numPurchaseQuotesLoading && !this.props.numPurchaseQuotesError) return <Spinner/>
      else if (this.props.numPurchaseQuotesError) {
        return <ContentWrapper>
              <div className="alert alert-danger">{JSON.stringify(this.props.numPurchaseQuotesError)}</div>
          </ContentWrapper>
      }
      else {
        return (
          <div className="dash-number">{this.props.numPurchaseQuotes}</div>
        )
      }
    }

    renderNumPurchaseOrdersNotReceived() {
      if (this.props.numPurchaseOrdersNotReceivedLoading && !this.props.numPurchaseOrdersNotReceivedError) return <Spinner/>
      else if (this.props.numPurchaseOrdersNotReceivedError) {
        return <ContentWrapper>
              <div className="alert alert-danger">{JSON.stringify(this.props.numPurchaseOrdersNotReceivedError)}</div>
          </ContentWrapper>
      }
      else {
        return (
          <div className="dash-number">{this.props.numPurchaseOrdersNotReceived}</div>
        )
      }
    }

    renderNumPurchaseOrdersNotPaid() {
      console.log("1", this.props.numPurchaseOrdersNotPaid)
      if (this.props.numPurchaseOrdersNotPaidLoading && !this.props.numPurchaseOrdersNotPaidError) return <Spinner/>
      else if (this.props.numPurchaseOrdersNotPaidError) {
        return <ContentWrapper>
              <div className="alert alert-danger">{JSON.stringify(this.props.numPurchaseOrdersNotPaidError)}</div>
          </ContentWrapper>
      }
      else {
        return (
          <div className="dash-number">{this.props.numPurchaseOrdersNotPaid}</div>
        )
      }
    }

    renderTotalPurchases() {
      if (this.props.numTotalPurchasesLoading && !this.props.numTotalPurchasesError) return <Spinner/>
      else if (this.props.numTotalPurchasesError) {
        return <ContentWrapper>
              <div className="alert alert-danger">{JSON.stringify(this.props.numTotalPurchasesError)}</div>
          </ContentWrapper>
      }
      else {
        return (
          <div className="dash-number">{this.props.numTotalPurchases}</div>
        )
      }
    }

    render() {
        const { handleSubmit, numPurchaseQuotes } = this.props;
        let height = (this.state.tableHeight+ 85).toString();
        let tableCollapseFix = {height: height};
        // Dummie Data
        var lineData = {
            labels: ["January", "February", "March", "April"],
            datasets: [
                {
                    label: "My First dataset",
                    fillColor: "rgba(220,220,220,0.2)",
                    strokeColor: "rgba(220,220,220,1)",
                    pointColor: "rgba(220,220,220,1)",
                    pointStrokeColor: "#fff",
                    pointHighlightFill: "#fff",
                    pointHighlightStroke: "rgba(220,220,220,1)",
                    data: [65, 59, 80, 81]
                },
                {
                    label: "My Second dataset",
                    fillColor: "rgba(151,187,205,0.2)",
                    strokeColor: "rgba(151,187,205,1)",
                    pointColor: "rgba(151,187,205,1)",
                    pointStrokeColor: "#fff",
                    pointHighlightFill: "#fff",
                    pointHighlightStroke: "rgba(151,187,205,1)",
                    data: [28, 48, 40, 19]
                }
            ]
        };

        var data = [
            {color: "#97ddf0", label: "test1", value: 2},
            {color: "#fafafa", label: "test2", value: 1}
        ];

        var options = {
            animateRotate: true
        }

        let createDialogStyle = {
            width: '600px',
            marginLeft: '-10%',
        };

        var purchaseOrderTablePanelHeader = (
          <Row>
            <Col xs={8}><h4><Translate value="purchase_order_arrivals" /></h4></Col>
            <Col xs={4}>
              {this.renderDatePicker(handleSubmit)}
            </Col>
          </Row>
        );

        var inventoryPanelHeader = ( <Row>
            <Col xs={8}><h4><Translate value="inventories" /></h4></Col>
            <Col xs={4}>
              <ButtonToolbar className="pull-right">
                  <Button
                      bsStyle="primary"
                      bsSize="small"
                      type="button"
                      onClick={ this.openFavoriteCreate }>
                      <em className="fa fa-plus" />
                  </Button>
                  <Button
                      bsStyle="danger"
                      bsSize="small"
                      type="button"
                      onClick={(event) => {
                          let newArray = this.state.favorites.rows;
                          this.state.favorites.selectedRows.map(row => {
                              this.props.deleteFavorite(row.Product_id);
                              newArray = newArray.filter(function (obj) {
                                return obj.Product_id !== row.Product_id;
                              });
                              var favorites = {...this.state.favorites, rows: newArray};
                              this.setState({favorites});
                          });
                      } }>
                      <em className="fa fa-close" />
                  </Button>
              </ButtonToolbar>
            </Col>
          </Row> );

        const ordersCreatedHeader = ( <h3><Translate value="orders_created_header" /></h3> );
        const poReceiveDate = ( <h3><Translate value="purchase_order_receive_rate" /></h3> );

        return (
          //---------------
          // Begin HTML
          //---------------
          <ContentWrapper>
            {/* Nav Trail */}
            <Breadcrumb>
              <Breadcrumb.Item active="true">
                <Translate value="purchase_dashboard" />
              </Breadcrumb.Item>
            </Breadcrumb>{/* End Nav Trail */}

            <Grid id="purchase-dashboard" fluid="true">
              <h1><Translate value="purchase_dashboard" /></h1>
              {/* Dashboard Panels */}
              <Row>
                <Time />
                <div className="col-sm-5ths">
                    <Link to="/purchaseQuote">
                        <div className="panel widget">
                            <Row className="row-table">
                                <Col sm={ 5 } className="bg-blue">
                                  {this.renderNumPurchaseQuotes()}
                                </Col>
                                <Col sm={ 7 }>
                                  <h3><Translate value="purchase_quotes" /></h3>
                                </Col>
                            </Row>
                        </div>
                    </Link>
                </div>
                <div className="col-sm-5ths">
                    <Link to="/purchaseOrder">
                        <div className="panel widget">
                            <Row className="row-table">
                                <Col sm={ 5 } className="bg-red">
                                  {this.renderNumPurchaseOrdersNotReceived()}
                                </Col>
                                <Col sm={ 7 }>
                                  <h3><Translate value="purchase_orders_not_received" /></h3>
                                </Col>
                            </Row>
                        </div>
                    </Link>
                </div>
                <div className="col-sm-5ths">
                  <Link to="/purchasePayment">
                    <div className="panel widget">
                        <Row className="row-table">
                            <Col sm={ 5 } className="bg-yellow">
                              {this.renderNumPurchaseOrdersNotPaid()}
                            </Col>
                            <Col sm={ 7 }>
                              <h3><Translate value="purchase_payment" /></h3>
                            </Col>
                        </Row>
                    </div>
                  </Link>
                </div>
                <div className="col-sm-5ths">
                    <div className="panel widget">
                        <Row className="row-table">
                            <Col sm={ 5 } className="bg-green">
                              {this.renderTotalPurchases()}
                            </Col>
                            <Col sm={ 7 }>
                              <h3><Translate value="total_purchases" /></h3>
                            </Col>
                        </Row>
                    </div>
                </div>
              </Row> {/* Dashboard Panels */}

              {/* Quick Actions */}
              <h2><Translate value="quick_actions" /></h2>
              <ButtonToolbar>
                <Button
                    bsStyle="success"
                    type="button"
                    onClick={(event) => {
                        this.clickNew(event)
                    } }>
                    <em className="fa fa-cart-plus" /><Translate value="create_new_purchase_order" />
                </Button>
                <Button
                    bsStyle="primary"
                    type="button"
                    onClick={ this.openQuoteCreate }>
                    <em className="fa fa-plus" /><Translate value="create_purchase_quote" />
                </Button>
                <Button
                    bsStyle="warning"
                    type="button"
                    onClick={(event) => {
                        this.createPurchaseReturn(event)
                    } }>
                    <em className="fa fa-backward" /><Translate value="process_purchase_return" />
                </Button>
              </ButtonToolbar> {/* End Quick Actions */}

              {/* Tables */}
              <Row>
                <Col sm={ 6 }>
                  <Panel header={purchaseOrderTablePanelHeader} style={ tableCollapseFix }>
                    {this.renderPurchaseOrderTable() }
                  </Panel>
                </Col>
                <Col sm={ 6 }>
                  <Panel header={inventoryPanelHeader} style={ tableCollapseFix }>
                    {this.renderInventoryTable() }
                  </Panel>
                </Col>
                {/* <Col sm={ 2 }>
                    <Panel header={ordersCreatedHeader}>
                      <h3><Translate value="1265" /></h3>
                    </Panel>
                    <Panel header={poReceiveRate}>

                    </Panel>
                </Col> */}
              </Row> {/* End Tables */}
            </Grid>

              <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.createQuoteOpen} onCloseClicked={() => {
                  this.closeQuoteCreate()
              } } title="Create a Purchase Quote">
                  <PurchaseQuoteModal closeC={this.closeQuoteCreate}/>
              </SkyLightStateless>
              <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.createFavoriteOpen} onCloseClicked={() => {
                  this.closeFavoriteCreate()
              } } title="Create a new Favorite">
                  <NewFavoriteModal closeC={this.closeFavoriteCreate} currentList={this.state.favorites} closeA={this.addFavorite}/>
              </SkyLightStateless>
          </ContentWrapper>
          //---------------
          // End HTML
          //---------------
        );
    }
}


export default PurchaseDashboard;



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/purchaseDashboard.jsx